import { render } from "./TimsLogo.vue?vue&type=template&id=13b6ba87"
import script from "./TimsLogo.vue?vue&type=script&lang=js"
export * from "./TimsLogo.vue?vue&type=script&lang=js"

import "./TimsLogo.vue?vue&type=style&index=0&id=13b6ba87&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__